<template>

  <div class="all">
    <headercon></headercon>
  </div>

</template>

<script>
import headercon from './header'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),

      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们'

    }
  },
  methods: {
    go () {
      this.$router.push({ path: '/gdproduct' })
    }
  }
}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/home1.png");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li1 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue